<footer class="app-footer">
  <div class="footer-content">
    <p>&copy; 2025 EfficX. All rights reserved.</p>
  </div>
</footer>
